import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import AuthSimpleLayout from "../layouts/AuthSimpleLayout";
import MainLayout from "../layouts/MainLayout";
import ErrorLayout from "../layouts/ErrorLayout";

import Error404 from "components/errors/Error404";
import Error500 from "components/errors/Error500";

import SimpleLogin from "components/authentication/simple/Login";
import SimpleLogout from "components/authentication/simple/Logout";
import SimpleForgetPassword from "components/authentication/simple/ForgetPassword";
import SimplePasswordReset from "components/authentication/simple/PasswordReset";

import Downloads from "components/downloads/Downloads";
import DownloadCategs from "components/downloads/DownloadCategories";
import Procurements from "components/procurements/Procurements";
import Settings from "components/settings/Settings";
import DynamicPage from "components/dynamic-pages/DynamicPage";
import NewsEvents from "components/newsevente/NewsEvents";
import Slider from "components/piccip-landing/Slider";
import Jobs from "components/jobs/Jobs";
import Leadership from "components/leadership/Leadership";
import Team from "components/leadership/Team";
import Scope from "components/piccip-landing/Scope";
import Users from "components/users/Users";
import ReChangePassword from "components/downloads/ChangePassword";

const FalconRoutes = () => {
  return (
    <Routes>
      <Route element={<ErrorLayout />}>
        <Route path="errors/404" element={<Error404 />} />
        <Route path="errors/500" element={<Error500 />} />
      </Route>
      

      <Route element={<AuthSimpleLayout />}>
        <Route path="/login" element={<SimpleLogin />} />
        <Route path="/logout" element={<SimpleLogout />} />
        <Route path="/forgot-password" element={<SimpleForgetPassword />} />
        <Route path="/update-password" element={<SimplePasswordReset />}
        />
        
        {/* <Route
          path="authentication/lock-screen"
          element={<SimpleLockScreen />}
        />
        <Route
          path="authentication/register"
          element={<SimpleRegistration />}
        />
        <Route
          path="authentication/confirm-mail"
          element={<SimpleConfirmMail />}
        /> */}

      </Route>



      {/* //--- MainLayout Starts  */}

      <Route element={<MainLayout />}>
        {/*Dashboard*/}
        <Route path="/" element={<Settings />} />

        <Route path="/reset-password" element={<ReChangePassword />} />

        <Route path="/downloads" element={<Downloads />} />
        <Route path="/download-categories" element={<DownloadCategs />} />


        <Route path="/procurements" element={<Procurements />} />
        <Route path="/jobs" element={<Jobs />} />
        {/* <Route path="/profile-settings" element={<Settings />} /> */}

        <Route path="/news&events" element={<NewsEvents />} />

        <Route path="/home/slider" element={<Slider />} />
        <Route path="/home/dreams-scope" element={<Scope />} />

        <Route path="/leadership" element={<Leadership />} />
        <Route path="/core-team" element={<Team />} />

        <Route path="/users" element={<Users />} />

        <Route path="/home/:pageNamee" element={<DynamicPage />} />
        <Route path="/pages/:pageNamee" element={<DynamicPage />} />
        

        
        {/* <Route path="/products" element={<Product />} />
        <Route path="/products/add-product" element={<AddProduct />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/add-user" element={<AddUser />} />
        <Route path="/roles" element={<RolesAndPermissions />} />
        <Route path="/roles/add-role" element={<AddRole />} />
        <Route path="/roles/assignment" element={<AddAssignment />} />
        <Route path="/infinite_scroll" element={<InfiniteScrollPage />} />
        <Route path="/products-tabs" element={<ProductsTabs />} />

        <Route path="/ag-grid" element={<DataGridSecond />} /> */}

        {/* <Route element={<WizardAuth />}>
          <Route path="/wizard" element={<Wizard validation={true} />} />
        </Route> */}


      </Route>

      <Route path="*" element={<Navigate to="/errors/404" replace />} />
    </Routes>
  );
};

export default FalconRoutes;
